// extracted by css-extract-rspack-plugin
export default {"cardWithCheckbox":"card-with-checkbox--DLo7ErfAgeY5hfCv"};